import { BankId } from '@tink/core/src/components/atoms/Icons/BankId';
import { styled } from '../../../../../../../core/theme/styled';

export const StyledBankId = styled(BankId)`
  margin-right: 12px;
`;
